import { Box, Text } from 'braid-design-system';
import type { ReactNode } from 'react';

import { trackPageInteraction } from 'src/modules/AnalyticsTracker';
import type { AnalyticsTrackingData } from 'src/types';

import * as styles from './TrackingMenuItem.css';

interface Props {
  label: string;
  key: string;
  href: string;
  icon?: ReactNode;
  target?: string;
  trackingEventName: string;
  trackingActionOrigin?: string;
  onClick?: () => void;
  trackingData?: AnalyticsTrackingData;
}

// Note this is not a component but a function returning a MenuItem.
// We are doing this to workaround a limitation in Braid that requires
// a Menu to only have children of type MenuItem or MenuItemLink.
// Due to the way Braid checks this we can't subclass to get around that
// and so will simply use a helper function to return an actual MenuItem.
export const getTrackingMenuItem = ({
  label,
  key,
  href,
  icon,
  target,
  onClick,
  trackingEventName,
  trackingActionOrigin,
  trackingData,
}: Props) => {
  const handleClick = () => {
    if (href === '#') {
      return;
    }

    if (trackingEventName) {
      trackPageInteraction(
        trackingEventName,
        trackingActionOrigin,
        trackingData,
      );
    }

    if (typeof onClick === 'function') {
      onClick();
    }

    if (target) {
      window.open(href, target);
    } else if (href) {
      window.location.href = href;
    }
  };

  return (
    <Box
      component="button"
      key={key}
      onClick={handleClick}
      className={styles.trackingMenuItem}
    >
      <Box marginRight="xsmall">{icon}</Box>
      <Text size="small">{label}</Text>
    </Box>
  );
};
